<div
    *ngrxLet="command() as currentCommand"
    class="st-duration-command-dialog__body">
    <st-duration-seconds-input-field
        [placeholder]="languageSettings()?.[ProductionCommandFieldsLabelKeys[currentCommand.commandType]]"
        [value]="currentCommand[ProductionFieldName.DURATION]"
        (enter)="onEnterSaveCommand($event)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.DURATION)" />
</div>
